<template>
  <div class="TAcircle">
    <div class="hd">TA关注的圈子</div>
    <div class="bd">
      <div v-show="loading">
        <loading></loading>
      </div>
      <div v-if="!loading && SelectCircleByAuthorId.length !==0">
        <ul class="of_h">
          <li class="fc_l"
              v-for="(item,index) in SelectCircleByAuthorId"
              :key="index">
            <router-link :to="'/circleDetail/'+item.id">
              <img :src="item.logo">

            </router-link>

            <div class="name">{{item.name}}</div>
          </li>
        </ul>

      </div>

      <div class="link"
           v-if="!loading && SelectCircleByAuthorId.length ==0">
        <router-link to="/communityCircle">TA还未加入任何圈子，不如去逛逛>></router-link>
      </div>

    </div>
  </div>
</template>

<script>
import loading from '@/components/loading/loading.vue'
import { topicDetail, selectCircleByAuthorId } from '@/utils/api/findDetail.js'
export default {
  name: "TAcircle",
  data () {
    return {
      loading: true,
      worksdetail: {},
      AuthorId: "",
      SelectCircleByAuthorId: []
    }
  },
  components: {
    loading
  },
  methods: {
    //获取作者关注的圈子
    getSelectCircleByAuthorId (authorId) {
      selectCircleByAuthorId({
        authorId: authorId
      }).then(res => {
        this.loading = false;
        this.SelectCircleByAuthorId = res.data.data;
      })
    },
    async getTopicDetail () {
      let topicDetailid = this.$route.params.id;
      let { data } = await topicDetail({ topicId: topicDetailid });
      this.worksdetail = data.data;
      this.AuthorId = this.worksdetail.topic.authorId;
      this.getSelectCircleByAuthorId(this.AuthorId);
    }
  },
  mounted () {
    this.getTopicDetail();
  }
}
</script>

<style lang="scss" scoped="scoped">
div.TAcircle {
  background: #fff;
  padding: 15px;
  padding-top: 5px;
  div.hd {
    height: 36px;
    line-height: 36px;
    font-size: 18px;
  }
  div.bd {
    ul {
      margin-top: 10px;
      li {
        display: block;
        width: 60px;
        margin-right: 20px;
        img {
          display: block;
          width: 60px;
          height: 60px;
          object-fit: cover;
        }
        div.name {
          width: 60px;
          height: 26px;
          line-height: 26px;
          font-size: 14px;
          text-align: center;
          overflow: hidden; /*超出部分隐藏*/
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          white-space: nowrap; /*规定段落中的文本不进行换行 */
        }
      }
    }
    div.link {
      margin-top: 15px;
      a {
        display: block;
        height: 20px;
        line-height: 20px;
        text-align: right;
        font-size: 12px;
        color: #a9a9a9;
      }
      a:hover {
        color: #f00;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/TAcircle/TAcircle.vue